<style>
    .page-content {
        margin-left: auto;
        margin-right: auto;
        width: calc(40ch + 40%);
    }
    @media screen and (min-width: 1500px) {
        .page-content {
            max-width: 1200px;
        }
    }
    @media screen and (max-width: 768px) {
        .page-content {
            width:auto;
            margin:10px;
        }
    }
</style>

<template>
    <div class="page-content">
        <slot />
    </div>
</template>

<script>
    export default {};
</script>
